import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, computed, signal } from '@angular/core';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import { ImageTrackerAssetCellTooltipComponent } from './image-tracker-asset-cell-tooltip/image-tracker-asset-cell-tooltip.component';

@Component({
    selector: 'app-image-tracker-asset-cell-renderer',
    imports: [TooltipDirective],
    templateUrl: './image-tracker-asset-cell-renderer.component.html',
    styleUrl: './image-tracker-asset-cell-renderer.component.scss',
})
export class ImageTrackerAssetCellRendererComponent implements ICellRendererAngularComp {
    readonly tooltipComponent = ImageTrackerAssetCellTooltipComponent;

    readonly thumbnailLink = signal<string>('');
    readonly publicMediaId = signal<number>(0);
    readonly mediaCaption = signal<string>('');
    readonly assetIndex = signal<number>(0);

    readonly tooltipData = computed(() => {
        return {
            thumbnailLink: this.thumbnailLink(),
            publicMediaId: this.publicMediaId(),
            mediaCaption: this.mediaCaption(),
            assetIndex: this.assetIndex(),
        };
    });

    agInit(
        params: ICellRendererParams<any, any, any> & {
            thumbnailLink: string;
            publicMediaId: number;
            mediaCaption: string;
            assetIndex: number;
        },
    ): void {
        this.thumbnailLink.set(params.thumbnailLink);
        this.publicMediaId.set(params.publicMediaId);
        this.mediaCaption.set(params.mediaCaption);
        this.assetIndex.set(params.assetIndex);
    }

    refresh(params: ICellRendererParams<any, any, any>): boolean {
        return true;
    }
}
